module.exports = __webpack_public_path__ + "img/t2.a3cb6281.png";